import { AppProvider } from './context/app/AppContext'
import theme from './theme'
import { Box, CssBaseline, ThemeProvider } from '@mui/material'
import { Loader } from './components/Loader'
import {
	AlertConductor,
	AlertProvider,
	Authenticate,
	AuthProvider,
	Me,
	ModalProvider
} from '@wolfdanepug/common-react'
import { ApolloProvider } from '@apollo/client'
import client from './graphql/client'
import { Outlet, useNavigate } from 'react-router'
import { PageProvider } from './context/page'

export default function App() {
	const navigate = useNavigate()

	return (
		<ThemeProvider theme={theme}>
			<AppProvider>
				<Loader />
				<AlertProvider>
					<ApolloProvider client={client}>
						<ModalProvider>
							<AuthProvider
								authenticateGraphQLDocument={Authenticate}
								contextUserGraphQLDocument={Me}
								redirectHandler={navigate}
							>
								<PageProvider>
									<CssBaseline />
									<AlertConductor placement="banner" />
									<Box sx={styles.content}>
										<Outlet />
									</Box>
									<AlertConductor placement="toast" />
									<AlertConductor placement="modal" />
								</PageProvider>
							</AuthProvider>
						</ModalProvider>
					</ApolloProvider>
				</AlertProvider>
			</AppProvider>
		</ThemeProvider>
	)
}

const styles = {
	content: {
		width: '100%',
		height: '100vh',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center'
	}
}
